<template>
  <div class="dados mt-5">
    <div class="row mt-3">
      <div class="col-9">
        <h1 class="font-weight-bold text-uppercase ml-2" id="inicio">Seus lojista cadastrado</h1>
      </div>
    </div>

    <hr class="linha-amarela ml-2" />

    <div class="d-flex justify-content-end">
      <b-button 
        class="mr-3" 
        variant="danger"
        @click="$refs.videoManual.toggleOpen({ 
          url: 'https://www.youtube.com/watch?v=OsH8gLG4ufE&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=13', 
          title: 'Novo lojista' 
        })"
      >
        <i class="fas fa-play mr-1"></i>
        Ver video
      </b-button>
    </div>
    <div class="row mt-4 container">
      <button class="btn btn-success" @click="newLojista()">
        <i class="fas fa-plus mr-2"></i>Novo lojista
      </button>
    </div>
    <div class="row mt-4">
      <div class="col-6">
        <label>Seu link de compartilhamento:</label>
        <input type="text" class="form-control" disabled v-model="value">
      </div>

      <div class="col-2 mt-4">
        <button class="btn btn-success btn-block mt-2" @click="copiarLink()">Copiar link</button>
      </div>

      <div class="col-2">
        <label>Cód. gerente:</label>
        <input type="text" class="form-control" disabled v-model="codGerente">
      </div>

      <div class="col-2 mt-4">
        <button class="btn btn-success btn-block mt-2" @click="copiarCod()">Copiar Cód.</button>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <i class="fas fa-users fa-2x c-orange mr-2"></i>
        <h4 class="text-uppercase c-orange font-weight-bold d-inline">
          Lojistas
        </h4>
      </div>
      
      <div class="col-12 mt-2">
        <table class="table">
          <thead class="letter-orange">
            <tr>
              <th scope="col">Nome responsável</th>
              <th scope="col">Nome fantasia</th>
              <th scope="col">CNPJ</th>
              <th scope="col">E-Mail</th>
              <th scope="col">Telefone / Celular</th>
              <th scope="col">Cidade - UF</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in data" :key="i">
              <td>{{ item.nome_responsavel }}</td>
              <td>{{ item.nome_fantasia }}</td>
              <td>{{ formatDoc('cnpj', item.cnpj) }}</td>
              <td>{{ item.email }}</td>
              <td>{{ formatDoc('cell', item.telefone) }} / {{ formatDoc('cell', item.celular) }}</td>
              <td>{{ item.cidade }} / {{ item.uf }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <b-modal
      title="Novo lojista"
      size="xl"
      id="addLojista"
      header-bg-variant="orange"
      header-text-variant="light"
      centered
      hide-footer>
        <div class="row">
          <div class="col-12">
            <shopkeeper-register
              :cities="cidades"
              :states="estados"
              :gerente="true"
              :gerenteId="dadosUsuario.informacoes.id"
              @update-lojista="updateLojista">
            </shopkeeper-register>
          </div>
        </div>
    </b-modal>
    <VideoManual ref="videoManual"/>
  </div>
</template>

<script>
import { mapState } from "vuex";
import makeToast from "../../mixins/makeToast";
import ShopkeeperRegister from '../lojista/Register.vue';
import VideoManual from '@/components/VideoManual.vue';

export default {
  name: "NovoLojista",
  mixins: [makeToast],

  components: {
    ShopkeeperRegister,
    VideoManual
  },

  data: () => ({
    value: '',
    codGerente: null,
    data: []
  }),

  computed: {
    ...mapState(['token', 'dadosUsuario', 'cidades', 'estados', 'segmentos'])
  },

  beforeCreate() {
    this.$store.dispatch('loadTipoUsuarios');
    this.$store.dispatch('loadEstados');
    this.$store.dispatch('loadCidades');
    this.$store.dispatch('loadPlanos');
    this.$store.dispatch('loadSegmentos');
  },

  created() {
    this.buscarLojistas();
    this.gerarLink();
  },

  methods: {
    gerarLink() {
      const link = process.env.VUE_APP_CURRENT_SITE_ADDRESS+'/area-restrita/cadastro-lojista';
      const path = '?gerente='+this.dadosUsuario.id;

      this.codGerente = this.dadosUsuario.id;
      this.value = link+path;
    },
    copiarLink() {
      navigator.clipboard.writeText(this.value);
      this.makeToast('Sucesso!', 'Link copiado com sucesso!', 'success');
    },
    copiarCod() {
      navigator.clipboard.writeText(this.codGerente);
      this.makeToast('Sucesso!', 'Código copiado com sucesso!', 'success');
    },
    newLojista() {
      this.$bvModal.show('addLojista');
    },
    updateLojista() {
      this.$bvModal.hide('addLojista');
      this.buscarLojistas();
    },
    formatDoc(tipo, value) {
      if(tipo == 'cnpj') {
        return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1 $2 $3/$4-$5");
      } else if(tipo == 'cell') {
        if (!value) return ""

        var value = value.replace(/\D/g, "");
        value = value.replace(/^0/, "");

        if (value.length > 10) {
          value = value.replace(/^(\d\d)(\d{5})(\d{4}).*/, "($1) $2-$3");
        } else if (value.length > 5) {
          value = value.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, "($1) $2-$3");
        } else if (value.length > 2) {
          value = value.replace(/^(\d\d)(\d{0,5})/, "($1) $2");
        } else {
          value = value.replace(/^(\d*)/, "($1");
        }
        return value;
      }
    },
    buscarLojistas() {
      this.$store.dispatch('startLoader');
        this.$store.dispatch('gerente/listarLojistas', this.dadosUsuario.informacoes.id)
          .then((response) => {
            if(response.data){
              this.data = response.data;
            }         
          })
          .catch(() => {
            this.makeToast('Oopss', 'Erro ao buscar lojistas!', 'danger')
          })
          .finally(() => {
            this.$store.dispatch('endLoader')
          });
    }
  },
};
</script>
